module.exports = __webpack_public_path__ + "img/logo.6039ac53.png";